import { createRouter, createWebHistory } from 'vue-router';

//Import pour décoder le token JWT
import { jwtDecode } from 'jwt-decode';

// Import des vues
import Home from '../views/HomeView.vue';
import Tarifs from '../views/TarifsView.vue';
import Contact from '../views/ContactView.vue';
import Legal from '../views/LegalView.vue';
import Plan from '../views/PlanView.vue';
import PrivacyPolicy from '../views/PrivacyPolicyView.vue';
import Cgu from '../views/CguView.vue';
import Cgv from '../views/CgvView.vue';
import Faq from '../views/FaqView.vue';

import NotFound from '../views/NotFoundView.vue';

// Import pour la page publique
import PublicPage from '../views/PublicPageView.vue';
import Preview from '../views/PreviewView.vue';

// Imports pour gestion user
import Login from '../views/LoginView.vue';
import Register from '../views/RegisterView.vue';
import Subscribe from '../views/SubscribeView.vue';


// Imports pour dashboard
import DashboardLayout from '../views/layouts/DashboardLayoutView.vue'
import Dashboard from '../views/DashboardView.vue';
import Profil from '../views/ProfilView.vue';

// Import pages admin
import Admin from '../views/AdminView.vue';
import AdminLogin from '../views/AdminLoginView.vue';




const routes = [
    { path: '/', name: 'Home', component: Home },
    { path: '/pricing', name: 'Tarifs', component: Tarifs },
    { path: '/login', name: 'Login', component: Login },
    { path: '/register', name: 'Register', component: Register },
    { path: '/subscribe', name: 'Subscribe', component: Subscribe },
    { path: '/public-page', name: 'PublicPage', component: PublicPage },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { requiresAuth: true } },
    { path: '/preview', name: 'Preview', component: Preview, meta: { requiresAuth: true } },
    { path: '/contact', name: 'Contact', component: Contact },
    { path: '/faq', name: 'Faq', component: Faq },
    { path: '/legal', name: 'Legal', component: Legal },
    { path: '/plan-site', name: 'Plan', component: Plan },
    { path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy },
    { path: '/cgu', name: 'Cgu', component: Cgu },
    { path: '/cgv', name: 'Cgv', component: Cgv },
    { path: '/admin', name: 'Admin', component: Admin, meta: { requiresAdmin: true } },
    { path: '/admin/login', name: 'AdminLogin', component: AdminLogin },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },

    // Structure avec layout pour dashboard
    {
        path: '/dashboard',
        component: DashboardLayout,
        meta: { requiresAuth: true },
        children: [
            { path: '', name: 'Dashboard', component: Dashboard },
            { path: 'profil', name: 'Profil', component: Profil }
        ]
    },

    // Route pour la page publique avec slug
    {
        path: '/:slug',
        name: 'PublicPageView',
        component: () => import('@/views/PublicPageView.vue'),
        beforeEnter: (to, from, next) => {
            const regex = /^entreprise-\d+$/;
            if (regex.test(to.params.slug)) {
                // empeche l'accès aux pages créees par l'utilisateur non abonné (ex: entreprise-1)
                next({ name: 'NotFound' });
            } else {
                next();
            }
        }
    }
];


// Création du routeur
const router = createRouter({
    history: createWebHistory(),
    routes,

    // FORCE LE SCROLL EN HAUT DE PAGE
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

// Guard d'authentification
router.beforeEach((to, from, next) => {
    // --- Auth utilisateur ---
    if (to.meta.requiresAuth) {
        const token = localStorage.getItem('token');
        if (!token) return next({ name: 'Login' });

        try {
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000;
            if (decoded.exp < currentTime) {
                localStorage.removeItem('token');
                return next({ name: 'Login' });
            }
        } catch (error) {
            localStorage.removeItem('token');
            return next({ name: 'Login' });
        }
    }

    // --- Auth admin ---
    if (to.meta.requiresAdmin) {
        const adminToken = localStorage.getItem('adminToken');
        if (!adminToken) return next({ name: 'AdminLogin' });

        try {
            const decodedAdmin = jwtDecode(adminToken);
            const currentTime = Date.now() / 1000;
            if (decodedAdmin.exp < currentTime) {
                localStorage.removeItem('adminToken');
                return next({ name: 'AdminLogin' });
            }
        } catch (error) {
            localStorage.removeItem('adminToken');
            return next({ name: 'AdminLogin' });
        }
    }

    next();
});


//push Google Tag Manager dataLayer events on route changes
router.afterEach((to) => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: "page_view",
            page_path: to.fullPath,
            page_title: document.title,
        });
    }
});

export default router;
